import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { DATA } from '@/plugins/vuex-async-pagginate';

class TrunkServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getSelect(params = { items_per_page: 500 }) {
    return super.getList(params).then((res) => res[DATA]);
  }

  addIps(trunk_id, params) {
    return this.http.post(`/${trunk_id}/ips`, { ...params });
  }

  getMoreIps(trunk_id) {
    return this.http.get(`/${trunk_id}/ips`);
  }

  removeIpFromIps(trunk_id, id) {
    return this.http.delete(`/${trunk_id}/ips/${id}`);
  }
}

export const TrunkService = new TrunkServiceClass({
  api_version: 2,
  resource: 'voice/trunks'
});
